import { render, staticRenderFns } from "./ConnectionMenu.vue?vue&type=template&id=126d9d44&"
import script from "./ConnectionMenu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConnectionMenu.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports